// Support inbox email when a host submits a listing for document review.
import React from 'react';
import PropTypes from 'prop-types';
import { Table, TBody, TR, TD } from 'oy-vey';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';

class CarListingSubmittedEmail extends React.Component {
  static propTypes = {
    content: PropTypes.shape({
      fullName: PropTypes.string,
      email: PropTypes.string,
      deviceType: PropTypes.string,
      listId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      reviewUrl: PropTypes.string,
      submittedAt: PropTypes.string,
      siteName: PropTypes.string,
      logo: PropTypes.string,
    }).isRequired,
  };

  render() {
    const {
      content: {
        fullName,
        email,
        deviceType,
        listId,
        reviewUrl,
        submittedAt,
        siteName,
        logo,
      },
    } = this.props;
    const textStyle = {
      color: '#333',
      backgroundColor: '#F7F7F7',
      fontFamily: 'Arial',
      fontSize: '16px',
      padding: '35px',
    };

    return (
      <Layout>
        <Header
          color="#2d8f4b"
          backgroundColor="#F7F7F7"
          logo={logo}
          siteName={siteName}
        />
        <Table width="100%">
          <TBody>
            <TR>
              <TD style={textStyle}>
                <div>
                  <b>New car listing submitted for review</b>
                </div>
                <EmptySpace height={20} />
                <div>
                  <b>Host name:</b> {fullName || '—'}
                </div>
                <EmptySpace height={10} />
                <div>
                  <b>Host email:</b> {email}
                </div>
                <EmptySpace height={10} />
                <div>
                  <b>Device:</b> {deviceType}
                </div>
                <EmptySpace height={10} />
                <div>
                  <b>Listing ID:</b> {listId}
                </div>
                <EmptySpace height={10} />
                <div>
                  <b>Submitted at:</b> {submittedAt}
                </div>
                <EmptySpace height={20} />
                {reviewUrl && (
                  <div>
                    <b>Review documents:</b>{' '}
                    <a href={reviewUrl}>{reviewUrl}</a>
                  </div>
                )}
                <EmptySpace height={30} />
                <EmailSignature siteName={siteName} />
              </TD>
            </TR>
          </TBody>
        </Table>
        <Footer siteName={siteName} />
      </Layout>
    );
  }
}

export default CarListingSubmittedEmail;
